import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Button, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { verifyForm, verifyAccount } from '../common/access-form-validation';
import { closeModal, openModalAlert } from '../../actions/index';
import { commonRenderInput } from '../common/access-form';
import { changeAccountName, DO_CHANGE_NAME_SUCCESS } from '../../actions/login/index';

class AccountSettingForm extends Component {


  formSubmit = (values) => {
    const { authToken, accountInfo, formValues, accountRole, timeZoneID, changeAccountName } = this.props;
    let reqBodyObj = {
      seq : accountInfo.seq,
      name : formValues.name,
      email: formValues.email,
      changeNameOnly : true
    };
    changeAccountName(authToken, accountInfo, accountRole, timeZoneID, reqBodyObj);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { status, closeModal } = this.props;
    if(prevProps.status !== status) {
      if(status === DO_CHANGE_NAME_SUCCESS){
        closeModal(null);
      } 
    }
  }


  renderAccountSettingForm = () => {
    const { handleSubmit, verifyFormPass, closeModal, errMsg } = this.props;

    let btnSubmit = (
      <>
        <Button id="account-setting-form-cancel" variant="primary" size="lg" bsPrefix='btn btn-close' block onClick={()=>closeModal(null)}>Cancel</Button>
        <Button id="account-setting-form-save" type="submit" variant="primary" size="lg" bsPrefix='btn btn-save' disabled={!verifyFormPass} block>Save</Button>
      </>
    );

    return (
      <form id="account-setting-form" className='reset-pwd-form' onSubmit={handleSubmit(this.formSubmit)}>
        <div className='area-form-field'>
          <Row>
            <Col sm={12}>
              <div className='area-form-label'>Name</div>
            </Col>
            <Col sm={12}>
              <Field id="account-setting-form-name" name="name" type="text" component={commonRenderInput} />
            </Col>
            <Col sm={12}>
              <div className='area-form-label'>Email</div>
            </Col>
            <Col sm={12}>
              <Field id="account-setting-form-email" name="email" type="text" component={commonRenderInput}  validate={verifyAccount}/>
            </Col>
          </Row>
          <div className='import-notice-text'> {errMsg ? errMsg : ''}  </div>  
        </div> 
        <hr/>     
        <div className='area-submit-btn'>
          {btnSubmit}
        </div>
      </form>
    )
  }

  render() {
    return (
      <div className='area-account-config-form form-custom'>
        { this.renderAccountSettingForm() }
      </div>
    );
  }
}

const warn = (values) => {
  return verifyAccount(values.email);
}

const getverifyField = (modalMessage) => {
  let verifyFields = null
  verifyFields = ['name', 'email'];
  return verifyFields
}

const mapStateToProps = (state, ownProps) => {
  const modalMessage = state.commonReducers.modalMessage
  const verifyFormPass = verifyForm(state.form['AccountSettingForm'], getverifyField(modalMessage));
  const accountInfo = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN)).accountInfo;


  let ret = {
    authToken: state.loginReducers.authToken,
    accountInfo: accountInfo,
    accountRole: state.loginReducers.accountRole,
    status: state.loginReducers.status,
    errMsg: state.loginReducers.errMsg,
    modalMessage: modalMessage,
    verifyFormPass: verifyFormPass,
    timeZoneID: state.loginReducers.timeZoneID,
    formValues: getFormValues('AccountSettingForm')(state),
  };

  let initialValues = {};
  initialValues['name'] = accountInfo['name'];
  initialValues['email'] = accountInfo['email'];
  ret['initialValues'] = initialValues;

  return ret;
};

AccountSettingForm = reduxForm({
  form: 'AccountSettingForm',  // a unique identifier for this form
  warn
})(AccountSettingForm)

export default withRouter(connect(
  mapStateToProps,
  { closeModal, changeAccountName, openModalAlert }
)(AccountSettingForm));